import {
  Card,
  CardContent,
  Stack,
  Button,
  Divider,
  Typography,
  Box,
  List,
  ListItem,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useUserData } from "../../hooks/use-data-user";
import { CodeQr } from "../CodeQr";

const CardUsdt = () => {
  const navigate = useNavigate();
  const { userDataQuery } = useUserData();

  const handleCopy = () => {
    navigator.clipboard.writeText(
      (!!userDataQuery.data &&
        userDataQuery.data.wallets.find((wallet) => wallet.name === "BSC")
          .address) ||
        ""
    );
    toast.success("Dirección de wallet copiada", {
      position: "top-center",
      style: {
        backgroundColor: "black",
        fontWeight: "700",
        fontFamily: "Arial",
        color: "#fff",
        fontSize: "16px",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
  };
  console.log(userDataQuery.data);
  return (
    <>
      <Toaster />
      <Card
        sx={{
          maxWidth: { xs: "320px", md: "600px" },
          backgroundColor: "rgba(20, 20, 20, 1)",
          border: "1px solid #a95052",
          borderRadius: "12px",
          paddingX: { xs: "20px", md: "35px" },
          paddingY: { xs: "15px", md: "25px" },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            justifyContent: "left",
            textAlign: "left",
            padding: "0px",
          }}
        >
          <Typography fontSize={18} color="white" sx={{ fontWeight: 400 }}>
            Para hacer tu primer compra debes depositar 115 USDT para:
          </Typography>
          <List sx={{ color: "white", paddingLeft: 4 }}>
            <ListItem
              sx={{
                display: "list-item",
                listStyleType: "disc",
                marginLeft: "5px",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                Compra mínima de token: 115 USDT
              </Typography>
            </ListItem>
          </List>

          <Typography fontSize={18} color="white">
            Importante:
          </Typography>
          <Typography variant="h6" color="white">
            Envía exclusivamente USDT a través de la red BSC (Binance Smart
            Chain - BEP-20) a la siguiente dirección de billetera:
          </Typography>

          <Box margin="auto" py={3} width={150} height={150}>
            <CodeQr
              image={"/assets/usdt.png"}
              value={
                (!!userDataQuery.data &&
                  userDataQuery.data.wallets.find(
                    (wallet) => wallet.name === "BSC"
                  ).address) ||
                ""
              }
            />
          </Box>

          <Divider />

          <Box display="flex" marginTop={1} justifyContent="space-between">
            <Typography
              maxWidth={310}
              fontSize={15}
              fontWeight={500}
              color="#98989A"
            >
              Red:
            </Typography>
            <Box display="flex" gap={2}>
              <Typography
                maxWidth={310}
                fontSize={15}
                fontWeight={500}
                color="#98989A"
              >
                BSC
              </Typography>
              <Box
                component="img"
                src="/bsc-logo.png"
                alt="hola"
                width={20}
                height={20}
              />
            </Box>
          </Box>
          <Typography
            paddingTop={1}
            fontSize={25}
            color="#a95052"
            sx={{ fontWeight: 600 }}
          >
            WALLET
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            paddingX="16px"
            bgcolor="rgba(26, 32, 44, 0.3)"
          >
            <Typography sx={{ wordBreak: "break-word", maxWidth: "100%" }}>
              {(!!userDataQuery.data &&
                userDataQuery.data.wallets.find(
                  (wallet) => wallet.name === "BSC"
                ).address) ||
                ""}
            </Typography>
            <IconButton onClick={handleCopy} sx={{ color: "white" }}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography
            paddingY={1}
            variant="h6"
            color="white"
            sx={{ fontWeight: 800 }}
          >
            No envíes otras criptomonedas ni utilices redes distintas, ya que
            esto podría ocasionar la pérdida irreversible de los fondos.
          </Typography>
          <Typography
            paddingY={2}
            fontSize={18}
            color="white"
            sx={{ fontWeight: 400 }}
          >
            Una vez completada la transferencia, recibirás un correo electrónico
            de confirmación de depósito. Ve a ver las propiedades disponibles
            para que selecciones y compres tu primer token inmobiliario.
          </Typography>
        </CardContent>

        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexDirection: { xs: "column-reverse", md: "row" },
          }}
        >
          <Button
            variant="contained"
            width="100%"
            onClick={() => navigate("/payments")}
            sx={{
              px: "80px",
              paddingX: { md: "50px", xl: "50px" },
              fontSize: { xs: "14px", md: "16px", xl: "16px" },
              borderRadius: "40px",
              color: "#f0e5d2",
              backgroundColor: "#a95052",
              "&:hover": {
                backgroundColor: "#8c3e47",
                color: "white",
              },
              transition: "background-color 0.3s ease, color 0.3s ease",
            }}
          >
            REGRESAR
          </Button>
          <Button
            variant="contained"
            width="100%"
            onClick={() => navigate("/")}
            sx={{
              paddingX: { xs: "50px", md: "50px" },
              fontSize: { xs: "14px", md: "16px", xl: "16px" },
              borderRadius: "40px",
              color: "#f0e5d2",
              backgroundColor: "#a95052",
              "&:hover": {
                backgroundColor: "#8c3e47",
                color: "white",
              },
              transition: "background-color 0.3s ease, color 0.3s ease",
            }}
          >
            VER PROPIEDADES
          </Button>
        </Stack>
      </Card>
    </>
  );
};

export default CardUsdt;
